import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     "SubscriptionId": "4bc1fb2b-eeb9-484d-ad33-dffc07573c29",
//     "SubscriptionName": "360T-G10",
//     "UserId": "19a482fe-3f6d-4d6f-8fdc-c1a812acf676",
//     "Email": "ondrej.sasinka@deutsche-boerse.com",
//     "Company": "ABC",
//     "sapBPId": "123456",
//     "sapBPName": "Doe Ltd.",
//     "sapContractId": "123",
//     "sapContractType": "abc",
//     "sapContractStartDate": 20200101,
//     "sapContractEndDate": 20200201,
//     "sapBillingContractId": "123",
//     "RangeType": "END_UNRESTRICTED",
//     "StartDate": 20220101,
//     "EndDate": 20221231,
//     "productCategory": "ANALYTICS"
// };

export default class SubscribersStatDataItemModel extends BaseModel {
    subscriptionId = 0;
    subscriptionName = "";
    userId = "";
    email = "";
    userFirstName = "";
    userLastName = "";
    additionalEmail2 = "";
    additionalEmail3 = "";
    company = "";
    bpId = 0;
    bpName = "";
    rangeType = "";
    startDate = 0;
    endDate = 0;
    productCategory = "";
    trial = false;
    salesTrial = false;

    constructor(data) {
        super();
        this.update(data);
    }
}
